/* Gota De Seda : page produit, script maison (14-10-2026). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var G = window.GDS || {};
  var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };

  /* ---------- minuteurs 10 min (bandeau + panier) ---------- */
  var t0 = Date.now(), DUR = 600;
  function tick() {
    var left = Math.max(0, DUR - Math.floor((Date.now() - t0) / 1000));
    var txt = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    $$('[data-gds-cart-timer]').forEach(function (e) { e.textContent = txt; });
    if (left > 0) setTimeout(tick, 1000);
  }
  tick();

  /* ---------- compte à rebours « La Oferta Termina en » : jusqu'à minuit, heure de Madrid ---------- */
  var cdEls = { h: $('[data-gds-cd="h"]'), m: $('[data-gds-cd="m"]'), s: $('[data-gds-cd="s"]') };
  function cdTick() {
    var left;
    try {
      var p = new Date().toLocaleTimeString('en-GB', { timeZone: 'Europe/Madrid', hour12: false }).split(':');
      left = 86400 - ((+p[0] % 24) * 3600 + (+p[1]) * 60 + (+p[2]));
    } catch (e) { var d = new Date(); left = 86400 - (d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds()); }
    var two = function (n) { return String(n).padStart(2, '0'); };
    cdEls.h.textContent = two(Math.floor(left / 3600)); cdEls.m.textContent = two(Math.floor(left % 3600 / 60)); cdEls.s.textContent = two(left % 60);
  }
  if (cdEls.h && cdEls.m && cdEls.s) { cdTick(); setInterval(cdTick, 1000); }

  /* ---------- menu (tiroir à gauche) ---------- */
  var menu = $('#gds-menu'), menuBtn = $('[data-gds-open-menu]');
  function openMenu() { menu.hidden = false; document.documentElement.classList.add('gds-lock'); menuBtn.setAttribute('aria-expanded', 'true'); requestAnimationFrame(function () { requestAnimationFrame(function () { menu.classList.add('is-open'); }); }); }
  function closeMenu() { menu.classList.remove('is-open'); document.documentElement.classList.remove('gds-lock'); menuBtn.setAttribute('aria-expanded', 'false'); setTimeout(function () { menu.hidden = true; }, 300); }
  if (menu && menuBtn) {
    menuBtn.addEventListener('click', openMenu);
    menu.addEventListener('click', function (e) {
      if (e.target.closest('[data-gds-close-menu]')) closeMenu();
      var a = e.target.closest('a');
      if (a && a.pathname === location.pathname && !a.hash) { e.preventDefault(); closeMenu(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) closeMenu(); });
  }

  /* ---------- header : se cache en descendant, revient en remontant ---------- */
  var hdr = $('#gds-header'), lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (hdr) hdr.classList.toggle('is-hidden', y > lastY && y > 200);
    lastY = y;
  }, { passive: true });

  /* ---------- galerie ---------- */
  var track = $('#gds-gal-track'), thumbs = $$('.gds-thumb');
  function galIndex() { return track ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
  function galGo(i) { if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
  if (track) {
    var n = track.children.length;
    $('.gds-gal__arrow--next').addEventListener('click', function () { var i = galIndex(); galGo(i >= n - 1 ? 0 : i + 1); });
    $('.gds-gal__arrow--prev').addEventListener('click', function () { var i = galIndex(); galGo(i <= 0 ? n - 1 : i - 1); });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { galGo(+b.dataset.i); }); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = galIndex();
        thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
        var a = thumbs[i], list = $('#gds-thumbs');
        if (a && list) { var li = a.parentNode; var x = li.offsetLeft - list.offsetLeft; if (x < list.scrollLeft || x + li.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollTo({ left: x - 10, behavior: 'smooth' }); }
      });
    }, { passive: true });
    var tl = $('#gds-thumbs');
    $('.gds-thumbs__nav--next').addEventListener('click', function () { tl.scrollBy({ left: 174, behavior: 'smooth' }); });
    $('.gds-thumbs__nav--prev').addEventListener('click', function () { tl.scrollBy({ left: -174, behavior: 'smooth' }); });
  }

  /* ---------- packs ---------- */
  var packs = $$('.gds-pack');
  function curVariant() { var r = $('.gds-pack input:checked'); return r ? +r.value : null; }
  packs.forEach(function (lab) {
    var r = $('input', lab);
    r.addEventListener('change', function () { packs.forEach(function (l) { l.classList.toggle('is-on', $('input', l).checked); }); });
  });

  /* ---------- interrupteurs (cadeaux + protección) ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.gds-gift .gds-switch');
    if (!sw) return;
    var on = sw.getAttribute('aria-checked') !== 'true';
    sw.setAttribute('aria-checked', on); sw.closest('.gds-gift').dataset.on = on ? '1' : '0';
  });

  /* ---------- panier ---------- */
  var CMP_TITLE = { '1 Cabezal + 6 Meses de Filtros': 10996, '1 Cabezal + 12 Meses de Filtros': 28987 };
  var CMP_HANDLE = { 'aro-masajeador-de-silicona': 1999, 'extension-garantia-5-anos': 1999, 'guia-cuidado-de-la-piel': 1999, 'guia-cuidado-del-cabello': 1999, 'envio-gratis': 699, 'pack-3-filtros-gratis': 2999 };
  var PROT_OFF = 'gds-prot-off';
  var store = { get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { v == null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v); } catch (e) {} } };
  var cartEl = $('#gds-cart');
  function api(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function cmpOf(it) { var c = CMP_HANDLE[it.handle] || (it.product_id && CMP_TITLE[it.variant_title]) || 0; return c > it.final_price ? c : 0; }
  function render(cart) {
    var box = $('[data-gds-items]'), prot = $('[data-gds-prot]'), protId = prot ? +prot.dataset.id : G.prot;
    var items = cart.items.filter(function (i) { return i.variant_id !== protId; }).reverse();
    var save = 0;
    box.innerHTML = items.map(function (it) {
      var c = cmpOf(it); save += c ? (c * it.quantity - it.final_line_price) : 0;
      var price = c ? '<s>' + money(c * it.quantity) + '</s>' + money(it.final_line_price) + '<small>(Ahorras ' + money(c * it.quantity - it.final_line_price) + ')</small>' : money(it.final_line_price);
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      return '<div class="gds-ci" data-key="' + it.key + '">' + (img ? '<img class="gds-ci__img" src="' + img + '" alt="">' : '') +
        '<div class="gds-ci__main"><div class="gds-ci__top"><div><div class="gds-ci__t">' + it.product_title + '</div>' + (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="gds-ci__v">' + it.variant_title + '</div>' : '') + '</div>' +
        '<button class="gds-ci__del" type="button" data-q="0" aria-label="Eliminar"><svg viewBox="0 0 24 24"><path d="M5 7h14M10 7V5h4v2M7 7l1 13h8l1-13" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></button></div>' +
        '<div class="gds-ci__bot"><div class="gds-qty"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Menos">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Más">+</button></div><div class="gds-ci__p">' + price + '</div></div></div></div>';
    }).join('');
    var hasProt = cart.items.some(function (i) { return i.variant_id === protId; });
    if (prot) { prot.hidden = !items.length; $('.gds-switch', prot).setAttribute('aria-checked', hasProt); }
    $('[data-gds-empty]').hidden = !!items.length;
    $('.gds-cart__foot').hidden = !items.length;
    $('.gds-cart__ship').hidden = !items.length;
    var sv = $('[data-gds-save]'); sv.textContent = '-' + money(save); sv.parentNode.hidden = !save;
    $('[data-gds-total]').textContent = money(cart.total_price);
    var cnt = $('[data-gds-count]'); if (cnt) { cnt.textContent = cart.item_count; cnt.hidden = !cart.item_count; }
  }
  function refresh() { return api('/cart.js').then(function (c) { render(c); return c; }); }
  function openCart() {
    cartEl.hidden = false; document.documentElement.classList.add('gds-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { cartEl.classList.add('is-open'); }); });
  }
  function closeCart() {
    cartEl.classList.remove('is-open'); document.documentElement.classList.remove('gds-lock');
    setTimeout(function () { cartEl.hidden = true; }, 300);
  }
  if (cartEl) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-gds-open-cart]')) { refresh(); openCart(); }
      if (e.target.closest('[data-gds-close-cart]')) closeCart();
      var q = e.target.closest('.gds-ci [data-q]');
      if (q) { var key = q.closest('.gds-ci').dataset.key; api('/cart/change.js', { id: key, quantity: Math.max(0, +q.dataset.q) }).then(render); }
      var ps = e.target.closest('[data-gds-prot] .gds-switch');
      if (ps) {
        var id = +ps.closest('[data-gds-prot]').dataset.id, on = ps.getAttribute('aria-checked') !== 'true';
        ps.setAttribute('aria-checked', on); store.set(PROT_OFF, on ? null : '1');
        (on ? api('/cart/add.js', { items: [{ id: id, quantity: 1 }] }) : api('/cart/change.js', { id: String(id), quantity: 0 })).then(refresh);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cartEl.hidden) closeCart(); });
  }

  /* ---------- ajout au panier ---------- */
  var atc = $('#gds-atc');
  if (atc) atc.addEventListener('click', function () {
    var vid = curVariant(); if (!vid || atc.classList.contains('is-loading')) return;
    atc.classList.add('is-loading');
    api('/cart.js').then(function (cart) {
      var inCart = {}; cart.items.forEach(function (i) { inCart[i.variant_id] = true; });
      var items = [{ id: vid, quantity: 1 }];
      $$('.gds-gift').forEach(function (g) { var id = +g.dataset.id; if (g.dataset.on === '1' && id && !inCart[id]) items.push({ id: id, quantity: 1 }); });
      if (G.prot && !inCart[G.prot] && !store.get(PROT_OFF)) items.push({ id: G.prot, quantity: 1 });
      return api('/cart/add.js', { items: items });
    }).then(function () { return refresh(); }).then(function () { openCart(); })
      .catch(function () { location.href = '/cart'; })
      .then(function () { atc.classList.remove('is-loading'); });
  });

  /* ---------- bouton collant « Ver la oferta » ---------- */
  var sticky = $('#gds-sticky'), offer = $('#gds-offer');
  if (sticky && offer) {
    var setSticky = function (on) { sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', !on); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { var e = es[0]; setSticky(!e.isIntersecting && e.boundingClientRect.bottom < 0); }).observe(offer);
    } else {
      var onScroll = function () { setSticky(offer.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    $('.gds-sticky__btn').addEventListener('click', function () {
      var y = $('.gds-offer__head').getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  /* ---------- carrousels simples ---------- */
  function slider(root, trackSel, prevSel, nextSel, opts) {
    var tr = $(trackSel, root); if (!tr) return;
    var n = tr.children.length, idx = function () { return Math.round(tr.scrollLeft / tr.clientWidth); };
    var go = function (i) { tr.scrollTo({ left: ((i + n) % n) * tr.clientWidth, behavior: 'smooth' }); };
    var prev = $(prevSel, root), next = $(nextSel, root);
    if (prev) prev.addEventListener('click', function () { go(opts.loop ? idx() - 1 : Math.max(0, idx() - 1)); });
    if (next) next.addEventListener('click', function () { go(opts.loop ? idx() + 1 : Math.min(n - 1, idx() + 1)); });
    var dots = opts.dots ? $$(opts.dots, root) : [];
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    var upd = function () {
      var i = idx();
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (!opts.loop) { if (prev) prev.disabled = i === 0; if (next) next.disabled = i === n - 1; }
    };
    tr.addEventListener('scroll', upd, { passive: true }); upd();
    if (opts.auto) {
      var seen = !('IntersectionObserver' in window);
      if (!seen) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }).observe(tr);
      var timer = setInterval(function () { if (seen && document.visibilityState === 'visible') go(idx() + 1); }, opts.auto);
      tr.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
    }
  }
  slider($('#gds-mini'), '.gds-mini__track', '.gds-mini__prev', '.gds-mini__next', { loop: false });
  slider($('#gds-slides'), '.gds-slides__track', '.gds-slides__prev', '.gds-slides__next', { loop: true, dots: '.gds-slides__dot', auto: 3000 });
  slider($('#gds-testi'), '.gds-testi__track', '.gds-testi__prev', '.gds-testi__next', { loop: true });

  /* ---------- avis : afficher plus ---------- */
  var more = $('[data-gds-more]');
  if (more) more.addEventListener('click', function () { more.closest('.gds-lx').classList.add('gds-lx--todo'); more.parentNode.remove(); });

  /* ---------- vidéos : chargées à l'approche, lues seulement à l'écran ---------- */
  var vids = $$('video[data-src]');
  var play = function (v) { v.muted = true; var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); };
  var load = function (v) { if (v.dataset.on) return; v.dataset.on = '1'; if (v.dataset.poster) v.poster = v.dataset.poster; v.src = v.dataset.src; v.preload = 'auto'; };
  if ('IntersectionObserver' in window) {
    var near = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { load(e.target); near.unobserve(e.target); } }); }, { rootMargin: '800px 0px' });
    var galNear = track && new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { load(e.target); galNear.unobserve(e.target); } }); }, { root: track, rootMargin: '0px 100%' });
    var shown = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { load(v); play(v); } else if (!v.paused) v.pause(); }); }, { threshold: 0.2 });
    vids.forEach(function (v) { (galNear && track.contains(v) ? galNear : near).observe(v); shown.observe(v); });
  } else vids.forEach(function (v) { load(v); play(v); });
})();

/* Martin 14-10 : pas de zoom (pincement ni double tap), même sur iPhone qui ignore user-scalable=no */
(function () {
  var stop = function (e) { e.preventDefault(); };
  ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (t) { document.addEventListener(t, stop, { passive: false }); });
  document.addEventListener('touchmove', function (e) { if (e.touches && e.touches.length > 1) e.preventDefault(); }, { passive: false });
  var last = 0;
  document.addEventListener('touchend', function (e) { var now = Date.now(); if (now - last < 300 && !e.target.closest('button,a,input,label,summary')) e.preventDefault(); last = now; }, { passive: false });
})();
